import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchWorkflowCampaignNodesQuery } from 'api/queries/workflows';
import { MessageMedium } from 'constants/messageMediums';
import { GraphQLWorkflowNodeResourceFilter } from 'modules/workflows';
import {
  GraphQLWorkflowCampaignNodeMetadataQueryVariables,
  WorkflowId,
  WorkflowType,
} from 'modules/workflowIndex/types';

type Campaign = {
  id: number;
  name: string;
  templateId: number;
  messageMedium: MessageMedium;
};
type QueryResponse = {
  workflow: {
    allNodes: {
      resource: {
        campaign?: Campaign;
        resources?: Campaign[];
      };
    };
  };
};
// there are two fetchWorkflowCampaignNodesQuery in our api/queries
// one in workflowIndex and another in workflows - this one uses workflows to grab
// the ChO campaign data as well
export const useWorkflowCampaignNodesWithCh0 = ({
  workflowId,
  workflowType,
}: {
  workflowId: WorkflowId;
  workflowType?: WorkflowType;
}) => {
  const { networkStatus, error, data } = useGraphql<
    QueryResponse,
    GraphQLWorkflowCampaignNodeMetadataQueryVariables
  >(fetchWorkflowCampaignNodesQuery, {
    fetchPolicy: 'cache-and-network',
    variables: {
      workflowId,
      workflowType,
      nodeResources: [GraphQLWorkflowNodeResourceFilter.Campaign],
    },
  });

  const isLoading = networkStatus < 7;
  const didError = !!error;
  const { allNodes = [] } = data?.workflow || {};

  return {
    isLoading,
    didError,
    allNodes,
  };
};
